/* STANDINGDATA */
import BasicLayout from '@/views/layouts/basic.vue';
import standingDataLandingPage from '@/views/standingData/landingPage.vue';
import productOverview from '@/views/standingData/products/list.vue';
import productDetails from '@/views/standingData/products/details.vue';
import provisioningServicesOverview from '@/views/standingData/provisioningServices/list.vue';
import provisioningServicesDetails from '@/views/standingData/provisioningServices/details.vue';
import productTermsOverview from '@/views/standingData/productTerms/list.vue';
import productTermsDetails from '@/views/standingData/productTerms/details.vue';
import pricePlansOverview from '@/views/standingData/pricePlans/list.vue';
import pricePlanOverview from '@/views/standingData/pricePlans/pricePlan/list.vue';
import pricePlansDetails from '@/views/standingData/pricePlans/details.vue';
import pricePlanDetails from '@/views/standingData/pricePlans/pricePlan/details.vue';
import pricePlansDuplicate from '@/views/standingData/pricePlans/duplicate.vue';
import partnerTypesDetails from '@/views/standingData/partnerAgreementTypes/details.vue';
import partnerTypesOverview from '@/views/standingData/partnerAgreementTypes/list.vue';
import recurringCommissionPlansOverview from '@/views/standingData/recurringCommissionPlans/list.vue';
import recurringCommissionPlansDetails from '@/views/standingData/recurringCommissionPlans/details.vue';
import recurringCommissionPlanSettings from '@/views/standingData/recurringCommissionPlans/settings.vue';
import groupsOverview from '@/views/standingData/groups/list.vue';
import groupsDetails from '@/views/standingData/groups/details.vue';
import logOverview from '@/views/standingData/logs/list.vue';
import logDetails from '@/views/standingData/logs/details.vue';
import queueMonitorOverview from '@/views/standingData/queueMonitors/list.vue';
import queueMonitorDetails from '@/views/standingData/queueMonitors/details.vue';
import odidoProductsOverview from '@/views/standingData/odidoProducts/list.vue';
import odidoProductsDetails from '@/views/standingData/odidoProducts/details.vue';
import kpnProductsOverview from '@/views/standingData/kpnProducts/list.vue';
import kpnProductsDetails from '@/views/standingData/kpnProducts/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
    path: 'stamgegevens',
    name: 'standingData',
    meta: {title: 'Stamgegevens'},
    redirect: '/stamgegevens/overzicht',
    component: BasicLayout,
    children: [
        // Overview routes
        {
            path: 'overzicht',
            name: 'standingData.overview',
            meta: {title: 'Overzicht stamgegevens'},
            component: standingDataLandingPage,
        },
        // Product routes
        {
            path: 'producten',
            name: 'standingData.products',
            meta: {title: 'Producten'},
            component: productOverview,
            children: [
                {
                    path: ':status',
                    name: 'standingData.products.status',
                    meta: {title: 'Producten'},
                    component: productOverview,
                },
            ],
        },
        {
            path: 'producten/toevoegen',
            name: 'standingData.products.add',
            meta: {title: 'Producten'},
            component: productDetails,
        },
        {
            path: 'producten/:id/wijzig',
            name: 'standingData.products.edit',
            meta: {title: 'Producten'},
            component: productDetails,
        },
        // Provisioning services
        {
            path: 'diensten',
            name: 'standingData.provisioningServices',
            meta: {title: 'Diensten'},
            component: provisioningServicesOverview,
        },
        {
            path: 'diensten/toevoegen',
            name: 'standingData.provisioningServices.add',
            meta: {title: 'Diensten'},
            component: provisioningServicesDetails,
        },
        {
            path: 'diensten/:id/wijzig',
            name: 'standingData.provisioningServices.edit',
            meta: {title: 'Diensten'},
            component: provisioningServicesDetails,
        },
        // Odido products
        {
            path: 'odido-products',
            name: 'standingData.odidoProducts',
            meta: {title: 'Odido Products'},
            component: odidoProductsOverview,
        },
        {
            path: 'odido-products/toevoegen',
            name: 'standingData.odidoProducts.add',
            meta: {title: 'Diensten'},
            component: odidoProductsDetails,
        },
        {
            path: 'odido-products/:id/wijzig',
            name: 'standingData.odidoProducts.edit',
            meta: {title: 'Diensten'},
            component: odidoProductsDetails,
        },
        // KPN products
        {
            path: 'kpn-products',
            name: 'standingData.kpnProducts',
            meta: {title: 'KPN Products'},
            component: kpnProductsOverview,
        },
        {
            path: 'kpn-products/toevoegen',
            name: 'standingData.kpnProducts.add',
            meta: {title: 'KPN Products'},
            component: kpnProductsDetails,
        },
        {
            path: 'kpn-products/:id/wijzig',
            name: 'standingData.kpnProducts.edit',
            meta: {title: 'KPN Products'},
            component: kpnProductsDetails,
        },
        // ProductTerms routes
        {
            path: 'termijnen',
            name: 'standingData.productTerms',
            meta: {title: 'Producttermijnen'},
            component: productTermsOverview,
        },
        {
            path: 'termijnen/toevoegen',
            name: 'standingData.productTerms.add',
            meta: {title: 'Producttermijnen'},
            component: productTermsDetails,
        },
        {
            path: 'termijnen/:id/wijzig',
            name: 'standingData.productTerms.edit',
            meta: {title: 'Producttermijnen'},
            component: productTermsDetails,
        },
        // PricePlans routes
        {
            path: 'prijsplannen',
            name: 'standingData.pricePlans',
            meta: {title: 'Prijsplannen'},
            component: pricePlansOverview,
        },
        {
            path: 'prijsplan/:ppId/wijzig',
            name: 'standingData.pricePlans.edit',
            meta: {title: 'Prijsplannen'},
            component: pricePlansDetails,
        },
        {
            path: 'prijsplan/toevoegen',
            name: 'standingData.pricePlans.add',
            meta: {title: 'Prijsplannen'},
            component: pricePlansDetails,
        },
        {
            path: 'prijsplan/:ppId/prijsplanregels',
            name: 'standingData.pricePlan.entries',
            meta: {title: 'Prijsplannen'},
            component: pricePlanOverview,
            children: [
                {
                    path: ':startDate/:endDate',
                    name: 'standingData.pricePlan.entries.filter',
                    meta: {title: 'Prijsplannen'},
                    component: pricePlanOverview,
                },
            ],
        },
        {
            path: 'prijsplan/:ppId/prijsplanregel/:id/wijzig/:startDate/:endDate',
            name: 'standingData.pricePlan.entries.edit',
            meta: {title: 'Prijsplannen'},
            component: pricePlanDetails,
        },
        {
            path: 'prijsplan/:ppId/prijsplanregel/toevoegen/:startDate/:endDate',
            name: 'standingData.pricePlan.entries.add',
            meta: {title: 'Prijsplannen'},
            component: pricePlanDetails,
        },
        {
            path: 'prijsplannen/dupliceren',
            name: 'standingData.pricePlans.duplicate',
            meta: {title: 'Prijsplannen'},
            component: pricePlansDuplicate,
        },
        // PartnerAgreementTypes routes
        {
            path: 'partner-types',
            name: 'standingData.partnerTypes',
            meta: {title: 'Partner types'},
            component: partnerTypesOverview,
        },
        {
            path: 'partner-types/:id/wijzig',
            name: 'standingData.partnerTypes.edit',
            meta: {title: 'Partner types'},
            component: partnerTypesDetails,
        },
        {
            path: 'partner-types/toevoegen',
            name: 'standingData.partnerTypes.add',
            meta: {title: 'Partner types'},
            component: partnerTypesDetails,
        },
        // RecurringCommissionPlans routes
        {
            path: 'commissieplannen',
            name: 'standingData.recurringCommissionPlans',
            meta: {title: 'Commissieplannen'},
            component: recurringCommissionPlansOverview,
        },
        {
            path: 'commissieplan/:planId',
            name: 'standingData.recurringCommissionPlans.matrix',
            meta: {title: 'Commissieplannen'},
            component: recurringCommissionPlansDetails,
            children: [
                {
                    path: 'matrix/:startDate/:endDate',
                    name: 'standingData.recurringCommissionPlans.matrix.filter',
                    meta: {title: 'Commissieplannen'},
                    component: recurringCommissionPlansDetails,
                },
            ],
        },
        {
            path: 'commissieplan/:planId/wijzig',
            name: 'standingData.recurringCommissionPlan.edit',
            meta: {title: 'Commissieplannen'},
            component: recurringCommissionPlanSettings,
        },
        {
            path: 'commissieplan/toevoegen',
            name: 'standingData.recurringCommissionPlan.add',
            meta: {title: 'Commissieplannen'},
            component: recurringCommissionPlanSettings,
        },
        // Groups routes
        {
            path: 'groepen',
            name: 'standingData.groups',
            meta: {title: 'Groepen'},
            component: groupsOverview,
            children: [
                {
                    path: ':type',
                    name: 'standingData.groups.filter',
                    meta: {title: 'Groepen'},
                    component: groupsOverview,
                },
            ],
        },
        {
            path: 'groep/:id/wijzig',
            name: 'standingData.groups.edit',
            meta: {title: 'Groepen'},
            component: groupsDetails,
        },
        {
            path: 'groep/toevoegen',
            name: 'standingData.groups.add',
            meta: {title: 'Groepen'},
            component: groupsDetails,
        },
        // Log routes
        {
            path: 'logs',
            name: 'standingData.logs',
            meta: { title: 'Logboeken' },
            component: logOverview,
        },
        {
            path: 'logs/:filename',
            name: 'standingData.logs.info',
            meta: { title: 'Logboeken' },
            component: logDetails,
        },
        // Queue Monitor routes
        {
            path: 'queue-monitor',
            name: 'standingData.queueMonitor',
            meta: { title: 'Queue Monitor' },
            component: queueMonitorOverview,
        },
        {
            path: 'queue-monitor/:id',
            name: 'standingData.queueMonitor.info',
            meta: { title: 'Queue Monitor' },
            component: queueMonitorDetails,
        },
    ],
};
